import { gql } from '@apollo/client';

export const CURRENT_USER_QUERY = gql`
  query initialData($environment: String) {
    me {
      id
      email
      isSuperUser
    }
    features(environment: $environment, scope: "nitrogen") {
      name
    }
    myIMSOrgs {
      id
      name
      targetClientCode
      tenantID
      region
      settings
      aep {
        id
        sandboxName
        imsOrg {
          id
          name
          settings
        }
      }
      acs {
        id
        url
        acsTenant
        imsOrg {
          id
          name
        }
      }
      acc {
        id
        url
        tenantID
        imsOrg {
          id
          name
        }
      }
      marketo {
        id
        url
        clientID
        clientSecret
        partition
        details
        imsOrg {
          id
          name
        }
      }
    }
  }
`;

export const CONFIGURATIONS_QUERY = gql`
  query configurations($category: String, $imsOrgId: String, $sandboxName: String) {
    configurations(
      category: $category
      imsOrgId: $imsOrgId
      sandboxName: $sandboxName
    ) {
      id
      category
      title
      description
      repository
      status
      content
      testRef
      prodRef
      stageRef
    }
  }
`;

export const MY_IMS_ORGS_QUERY = gql`
  {
    myIMSOrgs {
      id
      name
      targetClientCode
      tenantID
      region
      settings
      users {
        userID
        role
      }
      aep {
        id
        sandboxName
        imsOrg {
          id
          name
          tenantID
          region
          settings
        }
      }
      acs {
        id
        url
        imsOrg {
          id
          name
        }
      }
      acc {
        id
        url
        tenantID
        imsOrg {
          id
          name
        }
      }
      marketo {
        id
        url
        clientID
        clientSecret
        partition
        details
        imsOrg {
          id
          name
        }
      }
    }
  }
`;

export const MY_AEP_QUERY = gql`
  {
    myAEP {
      id
      sandboxName
      imsOrg {
        id
        name
        settings
      }
    }
  }
`;

export const AEP_BY_ID_QUERY = gql`
  query aepById(
    $id: String!
    $streamingEndpoint: Boolean!
    $details: Boolean!
  ) {
    aep(id: $id) {
      id
      sandboxName
      imsOrg {
        id
        name
        settings
      }
      launch {
        propertyName
        propertyID
        type
        launchUrl
        config
        primarySolution
        createdAt
        drNumber
      }
      streamingEndpoint @include(if: $streamingEndpoint)
      details @include(if: $details)
    }
  }
`;

export const MY_ACS_QUERY = gql`
  {
    myACS {
      id
      url
      imsOrg {
        id
        name
        settings
      }
    }
  }
`;

export const MY_LAUNCH_QUERY = gql`
  query myLaunch($orgID: String) {
    myLaunch(orgID: $orgID) {
      id
      propertyName
      propertyID
      type
    }
  }
`;

export const PROJECTS_BY_SANDBOX_QUERY = gql`
  query projectsBySandbox($imsOrgID: String!, $sandboxName: String!) {
    projectsBySandbox(imsOrgID: $imsOrgID, sandboxName: $sandboxName) {
      id
      name
      meta
    }
  }
`;

export const LAUNCH_BY_SANDBOX_QUERY = gql`
  query launchBySandbox($sandboxId: String!) {
    launchBySandbox(sandboxId: $sandboxId) {
      id
      propertyName
      propertyID
      type
      userID
      launchUrl
    }
  }
`;

export const DOCUMENT_QUERY = gql`
  query document($path: String!) {
    document(path: $path) {
      content
    }
  }
`;

export const MY_THIRD_PARTY_PRODUCTS = gql`
  {
    myThirdPartyProducts {
      id
      type
      name
      details
      credentials
    }
  }
`;

export const UPSERT_THIRD_PARTY_PRODUCT_MUTATION = gql`
  mutation (
    $id: Int
    $type: String!
    $name: String
    $details: JSON
    $credentials: JSON
  ) {
    upsertThirdPartyProduct(
      id: $id
      type: $type
      name: $name
      details: $details
      credentials: $credentials
    ) {
      id
      type
      name
      details
    }
  }
`;

export const DELETE_THIRD_PARTY_PRODUCT_MUTATION = gql`
  mutation ($id: Int!) {
    deleteThirdPartyProduct(id: $id)
  }
`;

export const MY_WORKSPACES_QUERY = gql`
  query myWorkspaces {
    ownedWorkspaces {
      id
      name
      livedemosWorkspaceId
    }
    sharedWorkspaces {
      id
      name
      livedemosWorkspaceId
    }
  }
`;

export const UPSERT_WORKSPACE_MUTATION = gql`
  mutation upsertWorkspace($id: String!, $livedemosWorkspaceId: String) {
    upsertWorkspace(id: $id, livedemosWorkspaceId: $livedemosWorkspaceId) {
      id
      livedemosWorkspaceId
    }
  }
`;
